import React from "react";
import { node } from "prop-types";
import Heading from "../Heading";

const UpdatesPageTemplateTitle = ({ children }) => (
	<Heading Tag="h2" className="updates-page-template__title">
		{children}
	</Heading>
);

UpdatesPageTemplateTitle.propTypes = {
	children: node.isRequired,
};

export default UpdatesPageTemplateTitle;
